/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React, { RefObject } from 'react';
import domToImage from 'dom-to-image';
import cameraImg from './dndimages/camera-icon.png';

interface DivToImageProps {
  targetRef: RefObject<HTMLElement>;
  filename: string;
}

const DivToImage: React.FC<DivToImageProps> = ({ targetRef, filename }) => {
  const handleConvert = async () => {
    if (targetRef.current) {
      try {
        const dataUrl = await domToImage.toPng(targetRef.current);
        const link = document.createElement('a');
        link.download = filename;
        link.href = dataUrl;
        link.click();
      } catch (err) {
        console.error('Oops, something went wrong converting the section to an image!', err);
      }
    }
  };

  return (
    <button onClick={handleConvert} title='Download a copy of this monster as an image'><img src={cameraImg} alt="download image" width='16px' /> Download Image</button>
  );
};

export default DivToImage;
